import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type CryptoDepositsState = {
    addresses: CryptoDepositAddress[];
    loading: boolean;
    onchainDeposits: OnchainDeposit[];
    onchainLoading: boolean;
    onchainPagination: {
        page: number;
        totalPages: number;
        totalElements: number;
        pageSize: number;
    };
    onchainFilters: OnchainDepositsFilter;
};

export const cryptoDepositsInitialState: CryptoDepositsState = {
    addresses: [],
    loading: false,
    onchainDeposits: [],
    onchainLoading: false,
    onchainPagination: {
        page: 1,
        totalPages: 1,
        totalElements: 0,
        pageSize: 10,
    },
    onchainFilters: {
        page: 1,
        pageSize: 10,
    },
};

const slice = createSlice({
    name: 'cryptoDeposits',
    initialState: cryptoDepositsInitialState,
    reducers: {
        setCryptoDepositAddressesAction(
            state,
            { payload }: PayloadAction<{ addresses: CryptoDepositAddress[] }>,
        ) {
            state.addresses = payload.addresses;
        },

        setCryptoDepositsLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },

        setOnchainDepositsAction(
            state,
            {
                payload,
            }: PayloadAction<{
                data: OnchainDeposit[];
                pagination?: {
                    page: number;
                    totalPages: number;
                    totalElements: number;
                    pageSize: number;
                };
            }>,
        ) {
            state.onchainDeposits = payload.data;
            if (payload.pagination) {
                state.onchainPagination = payload.pagination;
            }
        },

        setOnchainDepositsLoading(state, action: PayloadAction<boolean>) {
            state.onchainLoading = action.payload;
        },

        setOnchainDepositsFiltersAction(
            state,
            { payload }: PayloadAction<Partial<OnchainDepositsFilter>>,
        ) {
            state.onchainFilters = { ...state.onchainFilters, ...payload, page: 1 };
        },

        resetOnchainDepositsFiltersAction(state) {
            state.onchainFilters = { page: 1, pageSize: state.onchainFilters.pageSize };
        },
    },
});

export const {
    setCryptoDepositAddressesAction,
    setCryptoDepositsLoading,
    setOnchainDepositsAction,
    setOnchainDepositsLoading,
    setOnchainDepositsFiltersAction,
    resetOnchainDepositsFiltersAction,
} = slice.actions;
export default slice.reducer;
